// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Typography } from "@outschool/backpack";
import { useFeatureFlag } from "@outschool/ui-components-shared";
import React, { useState } from "react";

import TempMathImage from "../../../../images/category/math.jpg";
import TempScienceImage from "../../../../images/category/scienceAndNature.jpg";
import HeroLayoutWithTabs from "../../layout/HeroLayoutWithTabs/HeroLayoutWithTabs";
import { learnerRoutes } from "../../lib/Routes";
import { NotFoundPage } from "../NotFoundPage";
import MixTopicCard from "./MixTopicCard";
import MixTopicModal, { ModalMixTopic } from "./MixTopicModal";

const DUMMY_TOPICS = [
  {
    uid: "dummy1",
    title: "Math",
    description:
      "Math is the study of numbers, shapes, and patterns. It is a fundamental science that is used to understand the world around us. Math is used in many fields, including science, engineering, and technology.",
    imageUrl: TempMathImage,
    isDefault: true,
  },
  {
    uid: "dummy2",
    title: "Environmental Arts",
    description:
      "Environmental arts is the study of the environment and how it affects us. It is a multidisciplinary field that combines art, science, and technology to create works that explore the relationship between humans and the natural world.",
    imageUrl: TempScienceImage,
    isDefault: false,
  },
];

export default function LearnerDiscovery() {
  const isMixUpEnabled = useFeatureFlag("nav-pod-mix-up-machine");

  const [selectedTopics, setSelectedTopics] = useState<string[]>([]);
  const [openModalTopic, setOpenModalTopic] = useState<ModalMixTopic | null>(
    null,
  );
  const onModalClose = () => setOpenModalTopic(null);
  // TODO: trigger modal on async response from generate endpoint

  if (!isMixUpEnabled) {
    return <NotFoundPage />;
  }

  return (
    <HeroLayoutWithTabs currentPath={learnerRoutes.discoveryPath()}>
      <Box
        flex
        sx={{
          flexDirection: "column",
          marginTop: "1.5rem",
        }}
      >
        <Typography variant="h2">The Mix-Up Machine</Typography>
        <Typography
          variant="body1"
          sx={{ color: "grey.600", marginTop: "1rem" }}
        >
          Select 2 topics and mix them to explore your interests.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            marginY: "2em",
          }}
        >
          {DUMMY_TOPICS.map(topic => (
            <MixTopicCard
              key={topic.uid}
              title={topic.title}
              imageUrl={topic.imageUrl}
              isDefault={topic.isDefault}
              isSelected={selectedTopics.includes(topic.uid)}
              onCardClick={() => {
                if (selectedTopics.includes(topic.uid)) {
                  setSelectedTopics(
                    selectedTopics.filter(t => t !== topic.uid),
                  );
                } else if (selectedTopics.length < 2) {
                  setSelectedTopics([...selectedTopics, topic.uid]);
                } else {
                  return;
                }
              }}
              onButtonClick={() => {
                setOpenModalTopic({
                  uid: topic.uid,
                  title: topic.title,
                  description: topic.description,
                  imageUrl: topic.imageUrl,
                  isDefault: topic.isDefault,
                });
              }}
            />
          ))}
        </Box>
        <MixTopicModal topic={openModalTopic} onClose={onModalClose} />
      </Box>
    </HeroLayoutWithTabs>
  );
}
